import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-percent" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end col-md-6 col-sm-12" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_10 = { class: "setting-data" }
const _hoisted_11 = { class: "row align-items-center" }
const _hoisted_12 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_13 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "table" }
const _hoisted_16 = { class: "d-block d-md-none" }
const _hoisted_17 = { class: "d-block my-3" }
const _hoisted_18 = { class: "d-none d-md-block" }
const _hoisted_19 = { class: "d-none t-d-md-table-cell" }
const _hoisted_20 = { class: "d-none t-d-md-table-cell" }
const _hoisted_21 = { class: "d-none t-d-md-table-cell" }
const _hoisted_22 = { class: "d-none t-d-md-table-cell" }
const _hoisted_23 = { class: "d-none t-d-md-table-cell" }
const _hoisted_24 = { class: "d-none t-d-md-table-cell" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { colspan: "8" }
const _hoisted_28 = { class: "text-center py-2" }
const _hoisted_29 = {
  "show-md": "",
  "show-lg": "",
  "hide-sm": "",
  "hide-xs": "",
  class: "d-none d-md-block"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_32 = { style: {"padding":"5px 0"} }
const _hoisted_33 = { class: "bold" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { style: {"padding":"5px 0"} }
const _hoisted_36 = { class: "bold" }
const _hoisted_37 = { style: {"padding":"5px 0"} }
const _hoisted_38 = { class: "bold" }
const _hoisted_39 = { style: {"padding":"5px 0"} }
const _hoisted_40 = { class: "bold" }
const _hoisted_41 = { style: {"padding":"5px 0"} }
const _hoisted_42 = { class: "bold" }
const _hoisted_43 = { style: {"padding":"5px 0"} }
const _hoisted_44 = { class: "bold" }
const _hoisted_45 = { style: {"padding":"5px 0"} }
const _hoisted_46 = { class: "bold" }
const _hoisted_47 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_49 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-patch-plus-fill" }, null, -1)
const _hoisted_55 = { class: "d-flex" }
const _hoisted_56 = {
  class: "flex-fill",
  style: {"font-size":"14px"}
}
const _hoisted_57 = ["title", "onClick"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash-fill" }, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "d-none t-d-md-table-cell" }
const _hoisted_61 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_62 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_63 = { class: "d-none t-d-md-table-cell" }
const _hoisted_64 = { class: "d-none t-d-md-table-cell" }
const _hoisted_65 = { class: "d-none t-d-md-table-cell" }
const _hoisted_66 = { class: "d-none t-d-md-table-cell" }
const _hoisted_67 = { class: "sett-small-menu align-right" }
const _hoisted_68 = { class: "discl-menu dropdown" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_70 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_74 = ["onClick"]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-patch-plus-fill" }, null, -1)
const _hoisted_76 = { class: "d-flex align-items-center" }
const _hoisted_77 = {
  class: "flex-fill",
  style: {"font-size":"14px"}
}
const _hoisted_78 = ["title", "onClick"]
const _hoisted_79 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash-fill" }, null, -1)
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = { class: "col-md-6 col-sm-12" }
const _hoisted_82 = { class: "area-info" }
const _hoisted_83 = { class: "col-md-6 col-sm-12" }
const _hoisted_84 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_DiscountRecModal = _resolveComponent("DiscountRecModal")!
  const _component_DiscountRuleModal = _resolveComponent("DiscountRuleModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.list_of_discounts), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_8), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.list_of_discounts_msg), 1),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.language.discounts), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddEditDiscount(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.listOfDiscountWithRules.length == 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printListItems()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_14),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshList()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_15, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.language.discounts), 1)
                    ]),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.language.code), 1)
                  ]),
                  _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.language.name), 1),
                  _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.language.value), 1),
                  _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.language.start), 1),
                  _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.language.end), 1),
                  _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.language.customers), 1),
                  _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.language.products), 1),
                  _hoisted_25
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.listOfDiscountWithRules.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                      _createElementVNode("td", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemPageElts, (discRecTbl) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: discRecTbl.discount.IdDiscount
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_29, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.showAddEditDiscount(1, discRecTbl.discount))
                        }, _toDisplayString(discRecTbl.discount.DiscountCode), 9, _hoisted_30)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.language.code) + ": ", 1),
                          _createTextVNode("  "),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.showAddEditDiscount(1, discRecTbl.discount))
                          }, _toDisplayString(discRecTbl.discount.DiscountCode), 9, _hoisted_34)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.language.name) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", {
                            class: _normalizeClass({'text-danger': !discRecTbl.discount.IsStillActive, 'text-warning': discRecTbl.discount.IsStillActive && discRecTbl.discount.HasRules})
                          }, _toDisplayString(discRecTbl.discount.DiscountName), 3)
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.language.value) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(discRecTbl.discount.DiscValue)) + " %", 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.language.start) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatDate(discRecTbl.discount.StartDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.language.end) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getDiscEndDate(discRecTbl.discount)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.language.customers) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getCustomerInfo(discRecTbl.discount)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.language.products) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getProductInfo(discRecTbl.discount)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_47, [
                          _hoisted_48,
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddEditDiscount(1, discRecTbl.discount))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_50),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteDiscountRec(discRecTbl.discount))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_51),
                            (discRecTbl.discount.HasRules)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_52))
                              : _createCommentVNode("", true),
                            (discRecTbl.discount.HasRules)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.addEditDiscRule(0, discRecTbl.discount, null))
                                }, [
                                  _hoisted_54,
                                  _createTextVNode("  " + _toDisplayString(_ctx.language.add_rule), 1)
                                ], 8, _hoisted_53))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(discRecTbl.listOfRules, (oRule) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "dropdown-item py-2 rule-item",
                                key: oRule.IdDiscRule
                              }, [
                                _createElementVNode("span", _hoisted_55, [
                                  _createElementVNode("span", _hoisted_56, _toDisplayString(`${_ctx.appFxs.formatNumbers(oRule.MinQuant)} -> ${_ctx.appFxs.formatNumbers(oRule.MaxQuant)} (${oRule.DiscValue}%)`), 1),
                                  _createTextVNode("  "),
                                  _createElementVNode("a", {
                                    href: "javascript:;",
                                    class: "text-danger",
                                    title: _ctx.language.delete,
                                    onClick: ($event: any) => (_ctx.deleteDiscRuleRec(oRule))
                                  }, _hoisted_59, 8, _hoisted_57)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_60, [
                      _createElementVNode("span", {
                        class: _normalizeClass({'text-danger': !discRecTbl.discount.IsStillActive, 'text-warning': discRecTbl.discount.IsStillActive && discRecTbl.discount.HasRules})
                      }, _toDisplayString(discRecTbl.discount.DiscountName), 3)
                    ]),
                    _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.appFxs.formatNumbers(discRecTbl.discount.DiscValue)) + " %", 1),
                    _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.appFxs.formatDate(discRecTbl.discount.StartDate)), 1),
                    _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.getDiscEndDate(discRecTbl.discount)), 1),
                    _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.getCustomerInfo(discRecTbl.discount)), 1),
                    _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.getProductInfo(discRecTbl.discount)), 1),
                    _createElementVNode("td", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("span", _hoisted_68, [
                          _hoisted_69,
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddEditDiscount(1, discRecTbl.discount))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_71),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteDiscountRec(discRecTbl.discount))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                              _createTextVNode("  " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_72),
                            (discRecTbl.discount.HasRules)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_73))
                              : _createCommentVNode("", true),
                            (discRecTbl.discount.HasRules)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.addEditDiscRule(0, discRecTbl.discount, null))
                                }, [
                                  _hoisted_75,
                                  _createTextVNode("  " + _toDisplayString(_ctx.language.add_rule), 1)
                                ], 8, _hoisted_74))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(discRecTbl.listOfRules, (oRule) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "dropdown-item py-2 rule-item",
                                key: oRule.IdDiscRule
                              }, [
                                _createElementVNode("span", _hoisted_76, [
                                  _createElementVNode("span", _hoisted_77, _toDisplayString(`${_ctx.appFxs.formatNumbers(oRule.MinQuant)} -> ${_ctx.appFxs.formatNumbers(oRule.MaxQuant)} (${oRule.DiscValue}%)`), 1),
                                  _createTextVNode("  "),
                                  _createElementVNode("a", {
                                    href: "javascript:;",
                                    class: "text-danger p-1",
                                    title: _ctx.language.delete,
                                    onClick: ($event: any) => (_ctx.deleteDiscRuleRec(oRule))
                                  }, _hoisted_80, 8, _hoisted_78)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.listOfDiscountWithRules.length==0}])
            }, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.listOfDiscountWithRules.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("nav", _hoisted_84, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_DiscountRecModal, {
        visible: _ctx.isDiscModalVis,
        initialValues: _ctx.discModalInitVal,
        recordStatus: _ctx.discModalStatus,
        listOfProducts: _ctx.listOfProducts,
        listOfCustomers: _ctx.listOfCustomers,
        onCloseForm: _ctx.onDiscModalClose
      }, null, 8, ["visible", "initialValues", "recordStatus", "listOfProducts", "listOfCustomers", "onCloseForm"]),
      _createVNode(_component_DiscountRuleModal, {
        visible: _ctx.isDiscRuleModalVis,
        initialValues: _ctx.discRuleModalInitVal,
        recordStatus: _ctx.discRuleModalStatus,
        onCloseForm: _ctx.onDiscRuleModalClose
      }, null, 8, ["visible", "initialValues", "recordStatus", "onCloseForm"])
    ]))
  ], 64))
}